import styled from "styled-components";
import Theme from "../../../assets/img/icons/Article/Theme.svg";

function ThemePill() {
  return (
    <ContentEngagementStyle>
      <div className="content-engagement-pill-wrapper">
        <img src={Theme} alt="meter" />
        <span className="margin-left-xs">Theme</span>
      </div>
    </ContentEngagementStyle>
  );
}

export default ThemePill;

const ContentEngagementStyle = styled.div`
  .content-engagement-pill-wrapper {
    display: flex;
    background-color: #27ce0a;
    color: #fff;
    height: 23px;
    padding: 0px 10px;
    font-size: 14px;
    border-radius: 12px;
    font-family: "robotomedium", sans-serif;
    font-weight: 500;
    box-shadow: 0px 0px 10px -2px rgba(0, 0, 0, 40%);
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 2px;
    }
  }
`;
